import '../../../App.css';
import { useMediaQuery, IconButton, MenuItem } from '@mui/material';
import { Link } from "react-router-dom";
import { Button, Box, } from "@mui/material";
import MenuIcon from '@mui/icons-material/Menu';
import MobileLoggedInHeader from './Mobile/MobileLoggedInHeader';
import useStore from '../state-files/zustondStoreStates';

const HeaderItems = ({ anchorEl, handleCloseMenu, isLoggedIn, setIsLoggedIn,
    setCurrentCommunityId, setCurrentCommunityName,
    handleOpenMenu, isAdmin
}) => {

    const isMobile = useMediaQuery('(max-width:1300px)');
    const { setDiscussionPressed, setIsCommunityAdmin } = useStore();


    return (
        <Box sx={{ display: 'flex', }}>
            {isMobile ? (
                <>
                    <MenuItem component={Link} to="/communities" className={isLoggedIn ? '' : 'hidden'} onClick={() => { }}>Communities</MenuItem>
                    <MenuItem component={Link} to="/discussions" className={isLoggedIn ? '' : 'hidden'} onClick={() => {
                        setCurrentCommunityId(null);
                        setCurrentCommunityName(null);
                        setIsCommunityAdmin(false)
                        setDiscussionPressed(true);
                    }}>Discussions</MenuItem>


                    <IconButton id="hamburger-menu" color="inherit" sx={{ display: isLoggedIn ? 'none' : '' }} onClick={handleOpenMenu}>
                        <MenuIcon sx={{ display: isLoggedIn ? 'flex' : 'none' }} />
                    </IconButton>

                    <MenuItem component={Link} className={isLoggedIn ? 'hidden' : ''} to="/" onClick={() => { handleCloseMenu(); }}>Home</MenuItem>
                    <MenuItem component={Link} className={isLoggedIn ? 'hidden' : ''} to="/about" onClick={handleCloseMenu}>About</MenuItem>
                    <MenuItem component={Link} className={isLoggedIn ? 'hidden' : ''} to="/contact-us" onClick={handleCloseMenu}>Contact</MenuItem>

                    <MobileLoggedInHeader
                        anchorEl={anchorEl}
                        handleCloseMenu={handleCloseMenu}
                        isLoggedIn={isLoggedIn}
                        setIsLoggedIn={setIsLoggedIn}
                    />
                </>
            ) : (
                /* Desktop View - Your Original Buttons */
                <>
                    <Button className={isLoggedIn ? '' : 'hidden'} color="inherit" component={Link} to="/communities" onClick={() => { }} sx={{ marginRight: 'auto' }}> Communities </Button>
                    <Button className={isLoggedIn ? '' : 'hidden'} color="inherit" component={Link} to="/discussions" onClick={() => {
                        setDiscussionPressed(true);
                        setCurrentCommunityId(null);
                        setCurrentCommunityName(null);
                    }} sx={{ marginRight: 'auto' }} > Discussions </Button>
                    <Button color="inherit" component={Link} to="/adminPanel" sx={{ display: isAdmin ? 'flex' : 'none', marginRight: 'auto' }} > Admin Panel </Button>
                    <Box sx={{ flexGrow: 0.5 }} />
                    <Button className={isLoggedIn ? 'hidden' : ''} color="inherit" component={Link} to="/">Home</Button>
                    <Button className={isLoggedIn ? 'hidden' : ''} color="inherit" component={Link} to="/about">About</Button>
                    <Button className={isLoggedIn ? 'hidden' : ''} color="inherit" component={Link} to="/contact-us" >Contact</Button>

                </>
            )}
        </Box>
    )
};

export default HeaderItems;